/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { REMINDER_DAYPARTS, REMINDER_NUDGE_MODES, REMINDER_SITUATIONS } from '@repo/config';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const reminderNudgeActionSchema = z.object({
  id: z.string(),
  label: z.string(),
  url: z.string(),
});

export const getReminderNudgeV1ResponseDataSchema = z.object({
  headline: z.string(),
  message: z.string(),
  pepTalk: z.string(),
  variantId: z.string().nullable(),
  situation: z.enum(REMINDER_SITUATIONS).nullable(),
  daypart: z.enum(REMINDER_DAYPARTS),
  isCaughtUp: z.boolean(),
  stats: z.object({
    dueCount: z.number().int().min(0),
    currentStreak: z.number().int().min(0),
    maxStreak: z.number().int().min(0),
    streakAtRisk: z.boolean(),
    daysSinceLastActive: z.number().int().min(0).nullable(),
  }),
  primaryAction: reminderNudgeActionSchema.extend({ mode: z.enum(REMINDER_NUDGE_MODES) }),
  secondaryActions: z.array(reminderNudgeActionSchema),
});

export type IGetReminderNudgeV1ResponseData = z.infer<typeof getReminderNudgeV1ResponseDataSchema>;

export const getReminderNudgeV1ResponseSchema = createApiResponseSchema(
  getReminderNudgeV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetReminderNudgeV1ResponseData>>;

export type IGetReminderNudgeV1Response = IAPI<IGetReminderNudgeV1ResponseData>;
